import beTwMerge from '@/utils/beTwMerge';
import { isRichTextEmpty } from '@/utils/builderUtils';
import RichText from '@/components/RichText/RichText';
import Button from '../Button/Button';
import MissionTileIcon, { MissionTileIconProps } from './MissionTileIcon';

export type MissionCTA = {
  label: string;
  href: string;
  target?: string;
  color?: string;
};

export type MissionTileProps = {
  backgroundColor?: string;
  title?: {
    text?: string;
    textColor?: string;
  };
  iconTextColor?: string;
  icons?: MissionTileIconProps[];
  isSetMaxWidth?: boolean;
  description?: {
    text?: string;
    textColor?: string;
  };
  ctas?: MissionCTA[];
  ctaColor?: string;
  isFullBleed?: boolean;
};

export default function MissionTile({
  backgroundColor,
  title,
  iconTextColor,
  icons = [],
  isSetMaxWidth = true,
  description,
  ctaColor,
  ctas,
  isFullBleed = false,
}: MissionTileProps) {
  return (
    <div
      className={beTwMerge(
        'min-[1504px]:tw-w-full',
        !isFullBleed && 'tw-mx-4 lg:tw-mx-8 min-[1504px]:tw-w-[calc(100%-64px)]',
        isSetMaxWidth && 'tw-max-w-[1440px] min-[1504px]:tw-mx-auto'
      )}
    >
      <div
        className="tw-bg-color-dark-green tw-text-color-white tw-text-center tw-py-[40px] md:tw-py-[56px] tw-px-4 md:tw-px-8"
        style={{ backgroundColor }}
      >
        {title && title.text && !isRichTextEmpty(title.text) && (
          <div style={{ color: title.textColor }}>
            <RichText className="tw-mx-auto tw-max-w-[70%] tw-mt-0 tw-mb-8 [&>*]:!tw-mb-0" content={title.text} />
          </div>
        )}

        {icons.length > 2 && icons.length < 7 && (
          <div
            className="tw-mb-10 tw-gap-x-4 tw-gap-y-6 tw-flex tw-justify-center tw-flex-wrap md:tw-flex-nowrap"
            style={{ color: iconTextColor }}
          >
            {icons.map((icon, i) => (
              <MissionTileIcon key={i} {...icon} isFourIcons={icons.length === 4} iconTextColor={iconTextColor} />
            ))}
          </div>
        )}

        {description && description.text && (
          <div
            className={beTwMerge('tw-font-book tw-mx-auto md:tw-max-w-[70%]', ctas && ctas.length > 0 && 'tw-mb-10')}
            style={{ color: description.textColor }}
          >
            {description.text}
          </div>
        )}

        {ctas && ctas.length > 0 && (
          <div className="tw-space-y-4 md:tw-space-x-4 md:tw-space-y-0 tw-font-avenirmedium">
            {ctas?.map((cta, i) => (
              <Button
                key={i}
                type="secondary"
                color="white"
                label={cta.label}
                href={cta.href}
                styles={{ borderColor: ctaColor, color: ctaColor }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
